import React, { useRef, useEffect } from 'react'
import GamesStyle from './GamesStyle'
import Poster from '../../images/Poster.png'
import BSCode from '../../images/BSCodePoster.png'
import GameCard from './GameCard'
import LightGunPoster from '../../images/LightGun Poster.png'

const Games = () => {
  // const [scrolled, setScrolled] = useState(false)

  const containerRef = useRef(null)

  useEffect(() => {
    const container = containerRef.current
    let lastScrollPosition = container.scrollLeft

    const handleScroll = () => {
      const currentScrollPosition = container.scrollLeft
      const scrolledMoreThan5px =
        Math.abs(currentScrollPosition - lastScrollPosition) > 5

      if (scrolledMoreThan5px) {
        // Logic to handle scroll more than 5px goes here
        // setScrolled(true)
      }

      lastScrollPosition = currentScrollPosition
    }

    container.addEventListener('scroll', handleScroll)

    return () => {
      container.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <GamesStyle ref={containerRef}>
      <GameCard
        image={Poster}
        altText={'Squatch Quest'}
        title={'Squatch Quest'}
        firstPar={'A classic game for NES and digital download.'}
        secondPar={
          'Play as Sammy Squatchman in this packed action comedy adventure; learn sasquatch magic, talk to raccoons, impress a lady sasquatch and defeat the Dark Warlock to save the day!'
        }
        linkOne={'https://seasidestudios.itch.io/squatch-quest-nes'}
        linkTwo={
          'https://www.kickstarter.com/projects/seaside-studios/squatch-quest-a-new-game-for-nes'
        }
      />
      <GameCard
        image={BSCode}
        altText={'BS Code'}
        title={'BS Code'}
        firstPar={
          'Developing games can be tough especially when your AI coding buddy has a different opinion on things...'
        }
        secondPar={
          'Dive inside this fictional code editor in this 2D platformer and change the code of the game! Blast bugs, call functions, and nerd out in this super meta experience.'
        }
        linkOne={'https://seasidestudios.itch.io/bs-code'}
      />
      <GameCard
        image={LightGunPoster}
        altText={'Light Gun, NES laser tag'}
        title={'Light Gun'}
        firstPar={'Coming 2027 for NES'}
        secondPar={''}
        linkOne={''}
      />
    </GamesStyle>
  )
}

export default Games
